export { default } from "./sendActivationEmailDialog";
